import * as React from 'react';
import { styled, ThemeProvider } from '../theme-provider';
import { getBackgroundColorByAppearance, } from '../display-tag';
import { getCommonProps } from './common-props';
import { Alert, Info, CheckmarkCircle } from '@volkswagen-onehub/icons-core';
const StyledInputNotificationIcon = styled.div.withConfig({ displayName: "StyledInputNotificationIcon", componentId: "sc-k55ekb" }) `padding:0;height:auto;width:fit-content;gap:0;color:${getBackgroundColorByAppearance};background-color:transparent;`;
const getIconByAppearance = (appearance, iconVariant = 'small') => {
    switch (appearance) {
        case 'success':
            return React.createElement(CheckmarkCircle, { variant: iconVariant, "aria-hidden": true });
        case 'error':
            return React.createElement(Alert, { variant: iconVariant, "aria-hidden": true });
        default:
            return React.createElement(Info, { variant: iconVariant, "aria-hidden": true }); //icon for 'info'
    }
};
/*
This function is designed to be used only in a combination with TextInput, TextArea and Select components.
*/
export const InputNotificationIcon = (props) => {
    const { appearance, id, iconVariant, hideIcon, role } = props;
    const commonProps = getCommonProps(props);
    return (React.createElement(ThemeProvider, { theme: "main" },
        React.createElement(StyledInputNotificationIcon, Object.assign({ appearance: appearance === 'information' ? 'alert' : appearance, id: id, role: role }, commonProps), hideIcon ? undefined : getIconByAppearance(appearance, iconVariant))));
};
